import { render, staticRenderFns } from "./DataRowSkeleton.vue?vue&type=template&id=732e4b73"
import script from "./DataRowSkeleton.vue?vue&type=script&lang=ts"
export * from "./DataRowSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./DataRowSkeleton.vue?vue&type=style&index=0&id=732e4b73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports